import IconChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconChevronUp from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'

// Spread into every drawer AccordionHeader
export const ACCORDION_HEADER_ICONS = {
  iconCollapsed: (
    <Icon size={ICON_SIZES.MD}>
      <IconChevronDown size={ICON_SIZES.MD} />
    </Icon>
  ),
  iconExpanded: (
    <Icon size={ICON_SIZES.MD}>
      <IconChevronUp size={ICON_SIZES.MD} />
    </Icon>
  )
}
